import { createJob } from "@/modules/work/jobs/create/api";
import { formatDateForAPI } from "utils/utils";
import { invalidateAllJobQueries } from "@/modules/work/jobs/queries";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { coordinator, ...rest } = values;

  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
    start_date: formatDateForAPI(values.start_date) || null,
    end_date: formatDateForAPI(values.end_date) || null,
    coordinator: coordinator.id,
    status: values.status || "draft",
  };
}

export function useCreateJob() {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);

      const response = await createJob({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Job Created Successfully");
      invalidateAllJobQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
}
